import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux'
import IncodeAuth from './IncodeLivenessReactComponent';
import IncodeAuthV2 from './IncodeLivenessReactComponentV2';
import { livenessValidation } from '@/domains/auth/redux/authenticationReactive';


declare global {
  interface Window {
    OnBoarding?: any;
  }
}

interface IncodeFaceAuthProps {
  apiUrl: string;
  identityId: string;
  sessionToken: string;
  interviewId: string;
  sdkVersion: string;
  engineVersion?: string;
  livenessSessionId: string;
  onConnectionError?: () => void;
}


function IncodeFaceAuth({ apiUrl, identityId, sessionToken, interviewId, sdkVersion, engineVersion = '1', livenessSessionId, onConnectionError }: IncodeFaceAuthProps) {
  const [incodeResponse, setIncodeResponse] = useState<any>(null);
  const [isCompleted, setIsCompleted] = useState(false);
  const dispatch = useDispatch();

  // Move dispatch to useEffect to prevent render loop
  useEffect(() => {
    if (incodeResponse) {
      const isError = incodeResponse.error === true;
      const dispatchPayload = {
        liveness: !isError,
        data: {
          liveness_session_id: livenessSessionId,
          session_id: identityId,
          session_token: sessionToken,
          interview_id: interviewId,
          candidate: incodeResponse.candidate,
          error: isError,
          // V1 returns errorStatus (numeric), V2 returns errorCode (string).
          // Coalesce so persons-api can classify V2 failures the same way it
          // does V1 (both live under vendor_data.error_status server-side).
          error_status: incodeResponse.errorStatus ?? incodeResponse.errorCode ?? null,
          error_message: incodeResponse.errorMessage,
        },
      };
      if (process.env.NODE_ENV !== 'production') {
        // Dev-only diagnostic — payload contains the liveness session token,
        // never let this reach prod builds.
        // eslint-disable-next-line no-console
        console.log('[incode-liveness] incodeResponse (raw from V1/V2 engine)', incodeResponse);
        // eslint-disable-next-line no-console
        console.log('[incode-liveness] dispatch livenessValidation payload', dispatchPayload);
      }
      dispatch(livenessValidation(dispatchPayload));
    }
  }, [incodeResponse, dispatch, livenessSessionId, identityId, sessionToken, interviewId]);
  
  const handleIncodeResponse = (response: any) => {
    setIsCompleted(true);
    setIncodeResponse(response);
  };

  if (isCompleted) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100vh', backgroundColor: 'white', margin: 0, padding: 0 }}>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
        <div style={{ width: 40, height: 40, border: '4px solid #e0e0e0', borderTop: '4px solid #3b82f6', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
        <p style={{ marginTop: 16, color: '#6b7280', fontSize: 14 }}>Processing...</p>
      </div>
    );
  }
  
  if (engineVersion === '2') {
    return <IncodeAuthV2 apiUrl={apiUrl} identityId={identityId} sessionToken={sessionToken} callBack={handleIncodeResponse} onConnectionError={onConnectionError} />;
  }

  return <IncodeAuth apiUrl={apiUrl} identityId={identityId} sessionToken={sessionToken} sdkVersion={sdkVersion} callBack={handleIncodeResponse} onConnectionError={onConnectionError} />;
}
export default IncodeFaceAuth;